import React, { useState } from 'react'
import MyButton from '../../../UI/form/MyButton'
import MyModal from '../../../UI/modal/MyModal'
import BoxSeriesForm from './BoxSeriesForm'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

const BoxSeriesFormAdd = ({ series, boxId }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            {
                series ? <EditIcon /> : <AddIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Додати товар в коробку'}
            disableClickOutside={true}
            content={
                <BoxSeriesForm
                    boxId={boxId}
                    seriesBd={series}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default BoxSeriesFormAdd